@use 'sass:map';
@use '../../variables' as *;
@use 'common/assets/scss/global' as *;
@import '@fortawesome/fontawesome-svg-core/styles.css';

@keyframes shimmer {
  0% {
    background-position: 100% 0;
  }

  100% {
    background-position: -100% 0;
  }
}

.page-layout {
  display: grid;
  gap: 32px;

  > .header {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    gap: 24px;

    > .heading {
      align-self: flex-start;
      display: inline-flex;
      align-items: center;
      column-gap: 16px;

      > .btn-tertiary {
        align-self: flex-start;
        font-size: var(--#{$prefix}font-size-md);
      }

      > h1 {
        margin: 0;
      }
    }
  }

  @media (width >= map.get($grid-breakpoints, md)) {
    gap: 48px;

    > .header {
      flex-direction: row;

      > .heading {
        align-self: unset;
      }
    }
  }
}

#services-layout {
  position: fixed;
  inset: $header-height 0 0 0;
  z-index: -1;
  color: var(--#{$prefix}body);
  overflow-y: auto;
  background-color: var(--#{$prefix}body-bg);
  transition: margin-left 0.15s cubic-bezier(0.4, 0, 0.2, 1);

  > div {
    margin-top: 32px;
    margin-bottom: 40px;

    > .header > .sort {
      align-self: flex-end;
      font-size: var(--#{$prefix}font-size-sm);
      display: flex;
      align-items: center;
      column-gap: 15px;
    }

    > .error {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      > svg {
        font-size: 38px;
        margin-bottom: 14px;
        opacity: 0.1;
      }

      > p {
        white-space-collapse: preserve-breaks;
      }
    }

    > ul {
      @include unstyled-list;
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(154px, 1fr));
      // grid-auto-rows: 1fr; // Fix bug due to learn more
      gap: 24px 16px;

      > li {
        > a {
          @include unstyled-link;
        }

        &.skeleton {
          width: 100%;
          height: 150px;
          background: linear-gradient(90deg, #e9e9e9 30%, #f6f6f6 50%, #e9e9e9 70%);
          background-size: 200% 100%;
          animation: shimmer 1.5s infinite linear;
          border-radius: 10px;
        }
      }
    }

    > .empty {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100px;
    }
  }

  &:focus-visible {
    outline: 2px dotted var(--#{$prefix}primary);
    outline-offset: -2px;
    border-radius: 10px;
  }

  @media (width >= map.get($grid-breakpoints, md)) {
    > div {
      margin-bottom: 70px;

      > ul {
        gap: 16px;
      }
    }

    &.navigation-drawer-visible {
      margin-left: $drawer-width;
    }
  }
}
